import startSrc from "@/assets/icon/AvatarStarter.svg";
import bronzeSrc from "@/assets/icon/AvatarBronze.svg";
import silverSrc from "@/assets/icon/AvatarSilver.svg";
import diamondSrc from "@/assets/icon/AvatarDiamond.svg";
import platinumSrc from "@/assets/icon/AvatarPlatinum.svg";
import gladiatorSrc from "@/assets/icon/AvatarEliteGladiator.svg";

export const levelAvatarOptions = [
    { key: "start", label: "بدون سطح", icon: "ShieldIcon", src: startSrc, colorClass: "lvl-c--diamond" },
    { key: "bronze", label: "برنز", icon: "ShieldIcon", src: bronzeSrc, colorClass: "lvl-c--bronze" },
    { key: "silver", label: "نقره‌ای", icon: "AwardIcon", src: silverSrc, colorClass: "lvl-c--silver" },
    { key: "diamond", label: "الماس", icon: "HexagonIcon", src: diamondSrc, colorClass: "lvl-c--diamond" },
    { key: "platinum", label: "پلاتینیوم", icon: "LayersIcon", src: platinumSrc, colorClass: "lvl-c--platinum" },
    { key: "gladiator", label: "گلادیاتور", icon: "ZapIcon", src: gladiatorSrc, colorClass: "lvl-c--gladiator" }
];

export function getLevelAvatarMeta(key) {
    const k = String(key || "");
    const found = levelAvatarOptions.find((x) => String(x.key) === k);
    return (
        found || {
            key: k,
            label: k || "—",
            icon: "ImageIcon",
            src: null,
            colorClass: "lvl-c--neutral",
        }
    );
}
